// extracted by mini-css-extract-plugin
module.exports = {"FirstColumn":"Furniture_FirstColumn__jzmUO","SecondColumn":"Furniture_SecondColumn__X8O__","ThirdColumn":"Furniture_ThirdColumn__xVkPH"};